import httpClient from "@/_shared/http-client";
import urlBuilder from "@/stock/api-services/_urlBuilder";
import requestAdapter from "@/stock/api-services/_requestAdapter";
import { date, objectHelper } from "@/_shared/utils";

const remove = async (ids = [], type = 'cloth') => {
  const url = `${process.env.BACKEND_URL}/warehouse`;
  const queryOptions = {
    data: {
      ids,
      type,
    }
  };
  return await httpClient.delete(url, queryOptions);
};

const add = async (data = {}, type = "product", image = null) => {
  const url = `${process.env.BACKEND_URL}/warehouse/component`;
  data = objectHelper.createCopy(data);
  data.created_at = date.getIsoString();

  let body = { type, data };
  if (type === 'product') {
    const { product, referenced_tables } = requestAdapter.adaptProductForm(data);
    body = { ...body, data: product, referenced_tables };
  }
  if (image && image.name && image.content) {
    body.image = image;
  }
  const response = await httpClient.post(url, body).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

const edit = async (data = {}, type = "product", image = null) => {
  const url = `${process.env.BACKEND_URL}/warehouse/component`;
  data = objectHelper.createCopy(data);
  data.updated_at = date.getIsoString();
  delete data.balance;
  let body = { type, data };
  if (type === 'product') {
    const { product, referenced_tables } = requestAdapter.adaptProductForm(data);
    body = { type, data: product, referenced_tables };
  }
  if (image && image.name && image.content) {
    body.image = image;
  }
  console.log('BODY', JSON.stringify(body));
  const response = await httpClient.put(url, body).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

const get = (type = "products", joinsList = []) => async (id) => {
    let results = {};
    const url = urlBuilder.buildForStockComponentForm(type, id, joinsList);
    await httpClient
      .get(url)
      .then(({ data }) => results = data)
    return results;
  };

const getBalance = async (tableName = "products", id = 1) => {
  const entities = {
    stationery: "stationery_id",
    promotional_products: "promotional_product_id",
    packages: "package_id",
    cut_of_clothes: "cut_of_clothes_id",
    sewing_accessories: "sewing_accessory_id",
    cloths: "cloth_id",
    expendable_materials: "expendable_material_id",
    products: "product_id",
  };
  const entity = entities[tableName];
  const url = `${process.env.BACKEND_URL}/stock_component/balance?${entity}=${id}`;
  let balance = 0;
  await httpClient.get(url).then((response) => {
    balance = response.data.balance;
  });
  return balance;
};

export const stockComponentService = {
  remove,
  add,
  edit,
  get,
  getBalance,
};



// WEBPACK FOOTER //
// ./src/stock/api-services/stockComponentService.js